import { useState } from 'react'
import { INCIDENTS } from './nutritionFormat'

function NutritionRecordForm({ item, mode, onCancel, onSubmit }) {
  const plated = Array.isArray(item.items) && item.items.length > 0
  const half = Math.max(1, Math.round(Number(item.volume_ml || 0) / 2))
  const [consumed, setConsumed] = useState(String(half || 1))
  const [percent, setPercent] = useState('50')
  const [reason, setReason] = useState('')
  const [incident, setIncident] = useState(mode === 'incidente' ? 'engasgo' : '')
  const [note, setNote] = useState('')

  const submit = (event) => {
    event.preventDefault()
    const extra = {
      incident: incident || null,
      incidentNote: note.trim()
    }
    if (mode === 'parcial') {
      if (plated || !item.volume_ml) {
        const value = Number(percent)
        if (!Number.isInteger(value) || value < 1 || value > 100) return
        onSubmit({ outcome: 'parcial', acceptancePercent: value, ...extra })
        return
      }
      const ml = Number(consumed)
      if (!Number.isInteger(ml) || ml < 1) return
      onSubmit({ outcome: 'parcial', consumedMl: ml, ...extra })
      return
    }
    if (mode === 'recusa') {
      if (!reason.trim()) return
      onSubmit({ outcome: 'recusado', reason: reason.trim(), ...extra })
      return
    }
    if (!incident) return
    onSubmit({ outcome: 'total', ...extra })
  }

  return (
    <form className="nut-record-form" onSubmit={submit}>
      {mode === 'parcial' && (plated || !item.volume_ml) && (
        <>
          <input
            type="number"
            min="1"
            max="100"
            step="1"
            value={percent}
            aria-label="Percentual de aceite"
            onChange={(event) => setPercent(event.target.value)}
          />
          <span>%</span>
        </>
      )}
      {mode === 'parcial' && !plated && Boolean(item.volume_ml) && (
        <input
          type="number"
          min="1"
          max={item.volume_ml || 5000}
          step="1"
          value={consumed}
          aria-label="Volume aceito em ml"
          onChange={(event) => setConsumed(event.target.value)}
        />
      )}
      {mode === 'recusa' && (
        <input
          value={reason}
          maxLength={200}
          placeholder="Justificativa da recusa"
          aria-label="Justificativa da recusa"
          onChange={(event) => setReason(event.target.value)}
        />
      )}
      <select value={incident} aria-label="Intercorrência" onChange={(event) => setIncident(event.target.value)}>
        {mode !== 'incidente' && <option value="">Sem intercorrência</option>}
        {INCIDENTS.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
      <input
        value={note}
        maxLength={200}
        placeholder="Observação"
        aria-label="Observação da intercorrência"
        onChange={(event) => setNote(event.target.value)}
      />
      <button type="submit" className="patients-btn patients-btn--primary patients-btn--compact">Confirmar</button>
      <button type="button" className="patients-btn patients-btn--ghost patients-btn--compact" onClick={onCancel}>Cancelar</button>
    </form>
  )
}

export default NutritionRecordForm
